module.exports = "../../../../platform/assets/pageMainIcon/youth_danjuweihulei7.svg";